<template>
  <div>
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 10px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
 
 <card style="margin-bottom:50px">
 
 	  <div style="float:left;">  
 	 
 	  <p-button type="info"  @click="updateEntityFye()" >
        <i slot="label" class="nc-icon nc-bell-55"></i>
                Mark FYE Completed
     </p-button>
     
     
      <p-button v-if="coy.f_filing=='filed' || coy.f_filing=='not_due'" type="success" style="cursor:default" >
        <i slot="label" class="nc-icon nc-check-2"></i>
                F.S. Filing Not Due
     </p-button>
     
      <p-button v-else type="info"  @click="updateEntityFsFiling()" >
        <i slot="label" class="nc-icon nc-briefcase-24"></i>
                Mark F.S. Filing Done
     </p-button>
     
     
      

     
     
      <p-button v-if="coy.agm_filing==1" type="success"  style="cursor:default">
        <i slot="label" class="nc-icon nc-check-2"></i>
                AGM Done
     </p-button>
     
     
      <p-button v-else type="info"  @click="updateEntityAGMFiling()" >
        <i slot="label" class="nc-icon nc-briefcase-24"></i>
                 Mark AGM Done
     </p-button>
     
     
     
      <p-button v-if="coy.ar_filing==1" type="success"  style="cursor:default">
        <i slot="label" class="nc-icon nc-check-2"></i>
                AR Done
     </p-button>
     
     
     <p-button v-else type="info"  @click="updateEntityARFiling()" >
        <i slot="label" class="nc-icon nc-briefcase-24"></i>
                 Mark AR Done
     </p-button>
     
     
    </div>
     
     
     
    <div style="float:right">
     <p-button type="danger"  @click="goToResolutionBuilder()" >
      <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
               Task Builder
              </p-button>
              
     <p-button type="info"  @click="goToEntityDocuments()" >
      <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
              Document Browser
              </p-button>
              
              
  </div>
</card>



<card style="margin-bottom:50px">

  
     
     
	</card>


 <tabs pills icons centered tab-content-classes="tab-space">
	<tab-pane id="home" key="home">
	  <span slot="title">
		 <!-- <i class="nc-icon nc-umbrella-13"></i> --> General
	  </span>
<div>
 <h4 slot="header" class="card-title" style="font-weight:bold;">
     Company Details
    </h4>
</div>

<div class="row">
<div class="col-md-7">
	 
<card class="form-horizontal">

  
  
  <div v-if="coy.entity_former_name" class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Entity Former Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{coy.entity_former_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    

    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Registered Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{coy.registered_address}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Company UEN</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{coy.uen}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Company Type</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">{{coy.company_type}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Company Status</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">{{coy.company_status}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Incorporation Date</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">{{coy.date_incorp_str}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Sign-up Date</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">{{coy.date_signup_str}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    </card>
    
    
    
    
    
    <div>
    <h4 slot="header" class="card-title" style="font-weight:bold;margin-top:50px;">
     Deadlines
    </h4>
    </div>
    <card class="form-horizontal">
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Financial Year End</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">{{coy.date_fye_str}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Hold Next AGM By</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">{{coy.date_agm_deadline_str}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >File AR By</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">{{coy.date_ar_deadline_str}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
	
	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Submit ECI By</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        <span v-if="coy.is_eci_exempted==1">Exempted</span>
        <span v-else>{{coy.date_eci_deadline_str}}</span>
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >AGM Status</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        <span v-if="coy.agm_filing==2">Not Done</span>
        <span v-if="coy.agm_filing==1">Done</span>
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
        <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Annual Return Status</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        <span v-if="coy.ar_filing==2">Not Done</span>
        <span v-if="coy.ar_filing==1">Done</span>
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
    	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Financial Statements Filing Status</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        <span v-if="coy.f_filing=='due'">Due</span>
        <span v-if="coy.f_filing=='not_due'">Not Due</span>
        <span v-if="coy.f_filing=='filed'">Filed</span>
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
   

  </card>  
  
   <div class="row"> 
   	 <div style="margin-left:15px;">
   
  		  <h4 slot="header" class="card-title" style="font-weight:bold;margin-top:50px;">
   				  Point-Of-Contact
   		 </h4>
   	 </div>
   </div>
  
  <div class="row"> 
  	<div class="col-xl-6">
 		 
    
    <card class="form-horizontal">
    	 <div style="text-align:center;">
			<h4 class="card-title" style="font-weight:bold;">
			As Recorded Internally
			</h4>
		</div>
    
    
    	<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >First Name</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{poc.first_name}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Last Name</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{poc.last_name}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >ID No.</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{poc.gov_id}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
		<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Contact No,</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{poc.contact_num}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
		<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Email</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{poc.email}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
    
   	 </card>
   	 </div><!-- end col -->
    	<div class="col-xl-6">		
    	 <card class="form-horizontal">
    	 <div style="text-align:center;">
			<h4 class="card-title" style="font-weight:bold;">
				As Provided By Client
			</h4>
		</div>
    
    
    	<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >First Name</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{key_contact.first_name}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Last Name</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{key_contact.last_name}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
		
		
		<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Contact No.</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{key_contact.contact_number}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
		
		
		<div class="row cs_coy_detail_row" >
		  <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Email</label>
		  <div class="col-sm-7">
			<div class="cs_coy_detail1">{{key_contact.email}}</div>
		  </div>
		  <div class="col-sm-3 label-on-right">
		  </div>
		</div>
    
   	 </card>
    
    
    	
    	</div><!-- end col -->
    </div> <!-- end row -->
    
    
  </div>
  <!--end: left column - company details -->
  



  
  <div class="col-md-5 ml-auto">
  

  	<card class="form-horizontal">
  	
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >ECI Exempted</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	<span v-if="coy.is_eci_exempted==1">Yes</span>
        	<span v-else>No</span>
        </div>
      </div>
    
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >GST Registered</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	<span v-if="coy.is_gst==1">Yes</span>
        	<span v-else>No</span>
        </div>
      </div>
   
    </div>
    
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >AGM Exemption</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	<span v-if="coy.is_agm_exempted==1">Yes</span>
        	<span v-else>No</span>
        </div>
      </div>
   
    </div>
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Is Listed Company</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	<span v-if="coy.is_listed==1">Yes</span>
        	<span v-else>No</span>
        </div>
      </div>
   
    </div>
    
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Auditor</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
           <span v-if="coy.auditor">	{{coy.auditor}} </span>
           <span v-else>	- </span>
        </div>
      </div>
   
    </div>
    
    
     
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Notes</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
          <span v-if="coy.notes">	{{coy.notes}} </span>
         <span v-else>	- </span>
        </div>
      </div>
   
    </div>
    
    
    </card>
    
    
    <div>
    <h4 slot="header" class="card-title" style="font-weight:bold;margin-top:50px;">
     Principal Activities
    </h4>
    </div>
    
    <card class="form-horizontal">
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Activity (I) Code</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	{{coy.principal_activity_1_code}}
        </div>
      </div>  
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Activity (I) Title</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	{{coy.principal_activity_1_title}}
        </div>
      </div>  
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Activity (I) Description (Business Nature)</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	{{coy.principal_activity_1_desc}}
        </div>
      </div>  
    </div>
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Activity (II) Code</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	{{coy.principal_activity_2_code}}
        </div>
      </div>  
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Activity (II) Title</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	{{coy.principal_activity_2_title}}
        </div>
      </div>  
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-3 col-form-label cs_coy_detail_label1" >Activity (II) Description</label>
      <div class="col-sm-7">
        <div class="cs_coy_detail1">
        	{{coy.principal_activity_2_desc}}
        </div>
      </div>  
    </div>
    
    
    
  	</card>
  </div>
  



  <!--end: right column - company details -->
  </div>
  
  
  
  
  
	<!--end: company details -->
	
	<div class="row">
		<div class="col-xl-12">
		 <div>
    <h4 slot="header" class="card-title" style="font-weight:bold;margin-top:50px;">
     Notifications Sent (Scheduled Reminders)
    </h4>
    </div>
    
			  <div class="card">
   		
          <div class="card-body table-responsive table-full-width">
          	
				<el-table :data="notifications"">
					<el-table-column label="Mode Of Notification" property="mode" min-width=140></el-table-column>
					<el-table-column label="Type" min-width=320>
						<template slot-scope="scope">
							<span v-if="scope.row.notification_type=='passed_fye'"  > 
								Reminder: FYE Passed
							</span>	 
							<span v-if="scope.row.notification_type=='30d_to_agm'"  > 
								Reminder: 30 Day To AGM Deadline
							</span>	 
	
						</template>
					</el-table-column>
					<el-table-column label="Sent To" property="sent_to" min-width=220></el-table-column>
					<el-table-column label="Date Sent" property="date_sent" min-width=220></el-table-column>
				</el-table>
				
				
				
          </div>
        </div>
		
		</div>
	</div>
	
	
	
	<h4 style="font-weight:bold;">Actions</h4>
	<card>
	 <p-button v-if="0" type="danger"  @click="deleteEntity()" >
                <i slot="label" class="nc-icon nc-simple-remove"></i>
              <span style="text-decoration:line-through">  Delete Entity</span>
     </p-button>
      <p-button type="info"  @click="goEditEntity()" >
        <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Edit This Entity
     </p-button>
     
     
      <!--<p-button type="warning"  @click="goToDigitalMailbox()" >
        <i slot="label" class="nc-icon nc-email-85"></i> 
                 Digital Mailbox
     </p-button>-->
     
     
      <p-button type="info"  @click="goToClientPortalInfo()" >
        <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Client Portal
     </p-button>
     
     
      <p-button v-if="role=='admin'" type="info"  @click="goToEntityAssociates()" >
        <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Associates
     </p-button>
     
     
     
     
     
	</card>
	
	
	
	
	
	<div v-if="coy.user && coy.user.user_info" style="font-size:10px;">
	 Entity created by: {{coy.user.user_info.first_name}} {{coy.user.user_info.last_name}}
	</div>
          
 
 </tab-pane>
 
  <tab-pane id="tasks" key="tasks">
              <span slot="title">Tasks</span>         
          
 <!-- start tasks -->
        

<br/><br/><br/><br/>
 <h5 class="title">Tasks</h5>
 	<div class="card" style="">
      
          <div class="card-body table-responsive table-full-width">
            
          

            
             <tabs pills type="danger" icons centered tab-content-classes="tab-space">
	<tab-pane id="incompletetasks" key="incompletetasks">
	  <span slot="title">Open Tasks</span>
            <el-table :data="tasks_incomplete" @row-click="gotoEditTask" style="">
            	<el-table-column label="Task ID" property="id" ></el-table-column>
                <el-table-column label="Task Name" property="task_name" width="350" ></el-table-column>
                 <el-table-column label="Created" property="created_at_str" width="150"></el-table-column>
                <el-table-column label="Task Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.task_status===1">Pending</span>
           				 <span v-if="scope.row.task_status===2">Waiting For Signature</span>
           				 <span v-if="scope.row.task_status===3">Signed</span>
           				 <span v-if="scope.row.task_status===4">Completed</span>
           				 <span v-if="scope.row.task_status===5">Cancaelled</span>
          			</template>
                </el-table-column>
            <el-table-column label="Payment Status" >
                	<template slot-scope="scope">
           				 <span v-if="scope.row.payment_status===1">Paid</span>
           				 <span v-if="scope.row.payment_status===2">Not Paid</span>
           				 <span v-if="scope.row.payment_status===3">N.A</span>
           				 <span v-if="scope.row.payment_status===4">Refunded</span>
          			</template>
                </el-table-column>
                <el-table-column label="Deadline" property="deadline_date_str" ></el-table-column>
                <el-table-column label="Scheduled On" property="schedule_date_str"></el-table-column>
                
          <!--       <el-table-column label="View" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="gotoEditTask(scope.row)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>-->
               
               
              <!--  <el-table-column label="Category" 
                  :filters="[{ text: 'Directors\' Resolution', value: 1 }, 
                  { text: 'Shareholders\' Resolution', value: 2 }, 
                  { text: 'AGM (Minutes & Resolution)', value: 3 }, 
                  { text: 'EGM (Minutes & Resolution)', value: 4 }, 
                  { text: 'Notice For AGM', value: 5 }, 
                  { text: 'Share Certificate', value: 6 }, 
                  { text: 'Misc', value: 56 }, 
                  
                  
                  ]"
      			  :filter-method="filterTag"
     			  filter-placement="bottom-end"
                >
                	<template slot-scope="scope">
						<div style="text-align:center;">
						  <p-button type="default"  round outline size="sm" v-if="scope.row.category===1">Directors' Resolutions</p-button>
						  <p-button type="default"  round outline size="sm" v-if="scope.row.category===2">Shareholders' Resolution (EGM)</p-button>
						  <p-button type="default"  round outline size="sm" v-if="scope.row.category===3">AGM (Minutes & Resolution)</p-button>
						  <p-button type="default"  round outline size="sm" v-if="scope.row.category===4">EGM (Minutes & Resolution)</p-button>
						  <p-button type="default"  round outline size="sm" v-if="scope.row.category==5">Notice For AGM</p-button>
						  <p-button type="default"  round outline size="sm" v-if="scope.row.category==6">Share Certificate</p-button>
						  <p-button type="default"  round outline size="sm" v-if="scope.row.category==56">Misc</p-button>
						</div>
					  </template>
                
                </el-table-column>-->

            </el-table>
            </tab-pane>
            
            
            <tab-pane id="completedtasks" key="completedtasks">
	  		<span slot="title">Completed Tasks</span>
	  		 <el-table :data="tasks_completed" @row-click="gotoEditTask" style="margin-top:50px;">
            	<el-table-column label="Task ID" property="id" width="150"></el-table-column>
                <el-table-column label="Task Name" property="task_name" width="250"></el-table-column>
                 <el-table-column label="Created" property="created_at_str" width="150"></el-table-column>
                <el-table-column label="Task Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.task_status===1">Pending</span>
           				 <span v-if="scope.row.task_status===2">Waiting For Signature</span>
           				 <span v-if="scope.row.task_status===3">Signed</span>
           				 <span v-if="scope.row.task_status===4">Completed</span>
           				 <span v-if="scope.row.task_status===5">Cancaelled</span>
          			</template>
                </el-table-column>
                <el-table-column label="Payment Status" >
                	<template slot-scope="scope">
           				 <span v-if="scope.row.payment_status===1">Paid</span>
           				 <span v-if="scope.row.payment_status===2">Not Paid</span>
           				 <span v-if="scope.row.payment_status===3">N.A</span>
           				 <span v-if="scope.row.payment_status===4">Refunded</span>
          			</template>
                </el-table-column>
                
               <!--  <el-table-column label="View" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="gotoEditTask(scope.row)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>-->
                
                <el-table-column label="Deadline" property="deadline_date_str" ></el-table-column>
                <el-table-column label="Scheduled On" property="schedule_date_str"></el-table-column>

            </el-table>
	  
	  		</tab-pane>
    	</tabs>
            
            
            
          </div>
        </div>
 
   <h4 style="font-weight:bold;">Actions</h4>
	<card>
		<div style="">
			 <p-button type="info"  @click="goToCreateTask()" >
			   <i slot="label" class="nc-icon nc-settings-gear-65"></i>
					Create Custom Task
				  </p-button>
			 <p-button type="info"  @click="createAgmTask()" >
			   <i slot="label" class="nc-icon nc-settings-gear-65"></i>
					Create AGM & AR Tasks
				  </p-button>
		</div>
		
		<br/>
		<div style="font-size:10px;">
			<strong>Create Custom Task</strong> - Create a task that is not related to ACRA filings and shares. 
			<br/>
			<strong>Create AGM & AR Tasks</strong> - System will auto-generate tasks for the upcoming AGM and AR.
		</div>
		
	</card>
	
<!-- end tasks -->


    
          
	</tab-pane>
            
            
            
 <tab-pane id="officers" key="officers">
              <span slot="title">
                 <!-- <i class="nc-icon nc-shop"></i>--> Officers
              </span>


<br/><br/><br/><br/>
<!-- start officers -->
<h5 class="title">Directors & Officers</h5>

        <div class="card" style="">
        
          <div class="card-body table-responsive table-full-width">
         <tabs pills type="danger" icons centered tab-content-classes="tab-space">
			<tab-pane id="appointed" key="appointed">
             <span slot="title">Appointed</span>
             
				<el-table :data="officers_appointed" @row-click="viewOfficer" :row-class-name="officerPocRowClassName" style="cursor:pointer;">
					<el-table-column label="First Name" property="person.first_name" ></el-table-column>
					<el-table-column label="Last Name" property="person.last_name"></el-table-column>
					<el-table-column label="ID" property="person.gov_id" ></el-table-column>
					<el-table-column label="Citizenship" >
						<template slot-scope="scope">
							{{getCitizenship(scope.row.person.citizenship)}}
						</template>
					</el-table-column>
					<el-table-column label="Title" property="pivot.title"></el-table-column>
					<el-table-column label="Position" property="pivot.position">
						<template slot-scope="scope">
							{{getOfficerPosition(scope.row.pivot.position)}}
						</template>
					</el-table-column>
					<el-table-column label="Officer Status" property="pivot.status_str"></el-table-column>
					<el-table-column label="Point-Of-Contact?" >
						<template slot-scope="scope">
							<span v-if="scope.row.pivot.is_contact_person===1">Yes</span>
							<span v-if="scope.row.pivot.is_contact_person===2">No</span>
						</template>
					</el-table-column>
				</el-table>
			</tab-pane>
			<tab-pane id="resigned" key="resigned">
             <span slot="title">Resigned</span>
             		<el-table :data="officers_resigned" @row-click="viewOfficer">
					<el-table-column label="First Name" property="person.first_name" ></el-table-column>
					<el-table-column label="Last Name" property="person.last_name"></el-table-column>
					<el-table-column label="ID" property="person.gov_id" ></el-table-column>
					<el-table-column label="Citizenship" >
						<template slot-scope="scope">
							{{getCitizenship(scope.row.person.citizenship)}}
						</template>
					</el-table-column>
					<el-table-column label="Title" property="pivot.title"></el-table-column>
					<el-table-column label="Position" property="pivot.position">
						<template slot-scope="scope">
							{{getOfficerPosition(scope.row.pivot.position)}}
						</template>
					</el-table-column>
					<el-table-column label="Officer Status" property="pivot.status_str"></el-table-column>
				</el-table>
             </tab-pane>
             
             <tab-pane id="pending_officers" key="pending_officers">
             <span slot="title">Pending</span>
             		<el-table :data="officers_unconfirmed" @row-click="viewOfficer" style="cursor:pointer;">
					<el-table-column label="First Name" property="person.first_name" ></el-table-column>
					<el-table-column label="Last Name" property="person.last_name"></el-table-column>
					<el-table-column label="ID" property="person.gov_id" ></el-table-column>
					<el-table-column label="Citizenship" >
						<template slot-scope="scope">
							{{getCitizenship(scope.row.person.citizenship)}}
						</template>
					</el-table-column>
					<el-table-column label="Nationality" >
						<template slot-scope="scope">
							{{getCountry(scope.row.person.nationality)}}
						</template>
					</el-table-column>
					<el-table-column label="Title" property="pivot.title"></el-table-column>
					<el-table-column label="Position" property="pivot.position">
						<template slot-scope="scope">
							{{getOfficerPosition(scope.row.pivot.position)}}
						</template>
					</el-table-column>
					<el-table-column label="Officer Status" property="pivot.status_str"></el-table-column>
				</el-table>
             </tab-pane>
             </tabs>
			
          </div>
        </div>
      
      
      
 </tab-pane>
<!-- end officers -->


<!-- start shareholders -->


 <tab-pane id="shareholders" key="shareholders"> <span slot="title">Shareholders/Members</span>
   <br/><br/><br/><br/>
  <div v-if="entity_type ==7">
  
 	 <h5 class="title">Members</h5>
 	 
 	 
 	 	 <div class="card" style="">
   
          <div class="card-body table-responsive table-full-width">
          
          	 <tabs pills type="danger" icons centered tab-content-classes="tab-space">
			<tab-pane id="active" key="active">
             <span slot="title">Appointed</span>
				<el-table :data="members_appointed" @row-click="">
					<el-table-column label="First Name" property="person.first_name" ></el-table-column>
					<el-table-column label="Last Name" property="person.last_name"></el-table-column>
					<el-table-column label="Gov ID" property="person.gov_id" ></el-table-column>
					
				
				</el-table>
				
				
				<el-table :data="members_company_appointed" @row-click="" style="margin-top:80px;">
					<el-table-column label="Company Name" property="shareholder_company.company_name" ></el-table-column>
					<el-table-column label="Company Registration Number" property="shareholder_company.company_reg_num"></el-table-column>
					<el-table-column label="Rep's First Name" property="shareholder_company.person.first_name" ></el-table-column>
					<el-table-column label="Rep's Last Name" property="shareholder_company.person.last_name" ></el-table-column>
				
				</el-table>
				
				
			 </tab-pane>
			 <tab-pane id="inactive" key="inactive">
             <span slot="title">Resigned</span>
			 	<el-table :data="members_resigned" @row-click="">
					<el-table-column label="First Name" property="person.first_name" ></el-table-column>
					<el-table-column label="Last Name" property="person.last_name"></el-table-column>
					<el-table-column label="Gov ID" property="person.gov_id" ></el-table-column>
					
				
				</el-table>
				
				
				<el-table :data="members_company_resigned" @row-click="" style="margin-top:80px;">
					<el-table-column label="Company Name" property="shareholder_company.company_name" ></el-table-column>
					<el-table-column label="Company Registration Number" property="shareholder_company.company_reg_num"></el-table-column>
					<el-table-column label="Representative's Name"  >
						<template slot-scope="scope">
							 <span>{{scope.row.shareholder_company.person.first_name}} {{scope.row.shareholder_company.person.last_name}}</span>

						</template>
					</el-table-column>
					
				</el-table>
				
			  </tab-pane>
			  </tabs>
          </div>
        </div>
      
      
      
  
  </div>
  <!-- end members -->
  
  
<div v-if="entity_type!=7">        

<h5 class="title">Shareholders</h5>

<card >
	<div style="padding:30px 30px 30px;font-weight:bold;">
		Total Paid-up Capital: {{coy.total_paid_up_cap}} {{coy.total_paid_up_currency}}
	</div>
</card>
        <div class="card" style="">
   
          <div class="card-body table-responsive table-full-width">
          
          	 <tabs pills type="danger" icons centered tab-content-classes="tab-space">
			<tab-pane id="active" key="active">
             <span slot="title">Active</span>
				<el-table :data="shareholders_active" @row-click="viewShareholder" style="cursor:pointer;">
					<el-table-column label="First Name" property="person.first_name" ></el-table-column>
					<el-table-column label="Last Name" property="person.last_name"></el-table-column>
					<el-table-column label="Gov ID" property="person.gov_id" ></el-table-column>
					<el-table-column label="Share Type" >
						<template slot-scope="scope">
							 <span v-if="scope.row.pivot.share_type===1">Ordinary</span>
							 <span v-if="scope.row.pivot.share_type===2">Preference</span>
							  <span v-for="st in coy.share_types">
								<span v-if="scope.row.pivot.share_type==st.id">{{st.name}}</span>
						      </span>

						</template>
					</el-table-column>
					<el-table-column label="Num Shares" property="pivot.num_shares"></el-table-column>
					<el-table-column label="Paid-Up Capital">
						<template slot-scope="scope">{{scope.row.pivot.paid_up_capital}} {{scope.row.pivot.currency}}</template>
					</el-table-column>
				
				</el-table>
				
				
				<el-table :data="shareholder_companies_active"  @row-click="viewShareholderCompany" style="margin-top:80px;cursor:pointer">
					<el-table-column label="Company Name" property="shareholder_company.company_name" ></el-table-column>
					<el-table-column label="Company Registration Number" property="shareholder_company.company_reg_num"></el-table-column>
					<el-table-column label="Rep's First Name" property="shareholder_company.person.first_name" ></el-table-column>
					<el-table-column label="Rep's Last Name" property="shareholder_company.person.last_name" ></el-table-column>
					<el-table-column label="Share Type" >
						<template slot-scope="scope">
							 <span v-if="scope.row.pivot.share_type===1">Ordinary</span>
							 <span v-if="scope.row.pivot.share_type===2">Preference</span>
							  <span v-for="st in coy.share_types">
								<span v-if="scope.row.pivot.share_type==st.id">{{st.name}}</span>
						      </span>

						</template>
					</el-table-column>
					<el-table-column label="Num Shares" property="pivot.num_shares"></el-table-column>	
					<el-table-column label="Paid-Up Capital">
						<template slot-scope="scope">{{scope.row.pivot.paid_up_capital}} {{scope.row.pivot.currency}}</template>
					</el-table-column>		
				</el-table>
				
				
			 </tab-pane>
			 <tab-pane id="inactive" key="inactive">
             <span slot="title">Inactive</span>
			 	<el-table :data="shareholders_inactive" @row-click="viewShareholder" style="cursor:pointer;">
					<el-table-column label="First Name" property="person.first_name" ></el-table-column>
					<el-table-column label="Last Name" property="person.last_name"></el-table-column>
					<el-table-column label="Gov ID" property="person.gov_id" ></el-table-column>
					<el-table-column label="Share Type" >
						<template slot-scope="scope">
							 <span v-if="scope.row.pivot.share_type===1">Ordinary</span>
							 <span v-if="scope.row.pivot.share_type===2">Preference</span>
							 <span v-for="st in coy.share_types">
								  <span v-if="scope.row.pivot.share_type==st.id">{{st.name}}</span>
							  </span>

						</template>
					</el-table-column>
					<el-table-column label="Num Shares" property="pivot.num_shares"></el-table-column>
					<el-table-column label="Paid-Up Capital">
						<template slot-scope="scope">{{scope.row.pivot.paid_up_capital}} {{scope.row.pivot.currency}}</template>
					</el-table-column>
				
				</el-table>
				
				
				<el-table :data="shareholder_companies_inactive" @row-click="viewShareholderCompany" style="margin-top:80px;cursor:pointer;">
					<el-table-column label="Company Name" property="shareholder_company.company_name" ></el-table-column>
					<el-table-column label="Company Registration Number" property="shareholder_company.company_reg_num"></el-table-column>
					<el-table-column label="Representative's Name"  >
						<template slot-scope="scope">
							 <span>{{scope.row.shareholder_company.person.first_name}} {{scope.row.shareholder_company.person.last_name}}</span>

						</template>
					</el-table-column>
					<el-table-column label="Share Type" >
						<template slot-scope="scope">
							 <span v-if="scope.row.pivot.share_type===1">Ordinary</span>
							 <span v-if="scope.row.pivot.share_type===2">Preference</span>
							  <span v-for="st in coy.share_types">
								  <span v-if="scope.row.pivot.share_type==st.id">{{st.name}}</span>
							  </span>

						</template>
					</el-table-column>
					<el-table-column label="Num Shares" property="pivot.num_shares"></el-table-column>	
					<el-table-column label="Paid-Up Capital">
						<template slot-scope="scope">{{scope.row.pivot.paid_up_capital}} {{scope.row.pivot.currency}}</template>
					</el-table-column>	
				</el-table>
				
			  </tab-pane>
			  </tabs>
          </div>
        </div>
      
      
    

<!-- end shareholders -->


 <!-- start: share certificates -->  

<br/><br/><br/><br/>
   
<h5 class="title">Share Certificates</h5>
        <div class="card">
   
          <div class="card-body table-responsive table-full-width">
          
          	
				<el-table :data="coy.share_certificates"@row-click="goToCert" :row-class-name="scRowClassName" style="cursor:pointer;">
					<el-table-column label="Cert No" property="cert_number" ></el-table-column>
					<el-table-column label="Shareholder Name">
						<template slot-scope="scope">
							<span v-if="scope.row.shareholder.is_company!=1"> 
							 {{scope.row.shareholder.person.first_name}}  {{scope.row.shareholder.person.last_name}}
							</span>	 
							<span v-if="scope.row.shareholder.is_company==1"> 
							 {{scope.row.shareholder.shareholder_company.company_name}}  ({{scope.row.shareholder.shareholder_company.company_reg_num}})
							</span>
						</template>
					</el-table-column>

					<el-table-column label="Share Type" >
						<template slot-scope="scope">
							 <span v-if="scope.row.share_type===1">Ordinary</span>
							 <span v-if="scope.row.share_type===2">Preference</span>
							 <span v-for="st in coy.share_types">
								<span v-if="scope.row.share_type==st.id">{{st.name}}</span>
						      </span>

						</template>
					</el-table-column>
					<el-table-column label="Num Shares" property="num_shares"></el-table-column>
					<el-table-column label="Effective Date" property="effective_date" ></el-table-column>
					<el-table-column label="Status" >
						<template slot-scope="scope">
							 <span v-if="scope.row.status===1">Pending</span>
							 <span v-if="scope.row.status===4">Active</span>
							 <span v-if="scope.row.status===5">Cancelled</span>

						</template>
					</el-table-column>
				</el-table>
				
				
				
          </div>
        </div>
      
    <!-- end: share certificates -->  
    
    
     <!-- start: register of controllers -->  

<br/><br/><br/><br/>


   
<h5 class="title">Register Of Controllers</h5>
        <div class="card">
   		
          <div class="card-body table-responsive table-full-width">
          	<div class="text-muted" style="padding:0px 0px 10px 10px">* Based on Ordinary Shares only</div>
          	
				<el-table :data="register_controllers"" style="cursor:pointer;">
					<el-table-column label="Shareholder Name">
						<template slot-scope="scope">
							<span v-if="scope.row.shareholder.is_company!=1"> 
							 {{scope.row.shareholder.person.first_name}}  {{scope.row.shareholder.person.last_name}}
							</span>	 
							<span v-if="scope.row.shareholder.is_company==1"> 
							 {{scope.row.shareholder.shareholder_company.company_name}}  ({{scope.row.shareholder.shareholder_company.company_reg_num}})
							</span>
						</template>
					</el-table-column>

					<el-table-column label="Ownership" >
						<template slot-scope="scope">
							 <span >{{scope.row.percentage}} %</span>
						</template>
					</el-table-column>
					<el-table-column label="Num Shares" property="num_shares">
						<template slot-scope="scope">
							 <span >{{scope.row.num_shares}} Ordinary</span>
						</template>
					</el-table-column>
					<el-table-column label="Effective Date" property="effective_date_str" ></el-table-column>
				</el-table>
				
				
				
          </div>
        </div>
      
    <!-- end: register of controllers -->  
    
    <br/><br/><br/>
    <h4 style="font-weight:bold;">Actions</h4>
   <card>
      <p-button type="info"  @click="displayCreateCustomShareTypeForm()" >
      			  <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Create Custom Share Type
        </p-button>
   </card>
   <div v-if="displayCreateCustomShareType">
   <!-- start: share types-->

	<h5 class="title">Custom Share Types</h5>

    <card  class="col-sm-7"> 	
				<el-table :data="coy.share_types"  >
					<el-table-column label="Share Type Name" property="name" ></el-table-column>
				</el-table>


   
    
    <br/><br/><br/>
    <div class="row">
      <div class="col-sm-6">
        <fg-input type="text"
                  name="new_share_type.name"
                  placeholder="Create New Share Type"
                  v-model="new_share_type.name">
        </fg-input>  <p-button   type="info" @click.prevent="createShareType">Create New Share Type</p-button>
      </div>

    </div>
    
     </card>

	</div>
    <!-- end: share types-->
    
    </div>
    <!-- end company with shareholders -->
    
</tab-pane>

 <tab-pane id="changes" key="changes" >
              <span slot="title">Changes</span>


	<!-- start officer changes:completed -->
<br/><br/><br/><br/>
<h5 class="title">Register Changes: Officers</h5>
<div style=""></div>
        <div class="card" style="margin-bottom:50px">

          <div class="card-body table-responsive table-full-width">
            <el-table :data="officerChanges_completed" @row-click="goToEditOfficerChange">
                <el-table-column label="First Name" property="officer.person.first_name" ></el-table-column>
                <el-table-column label="Last Name" property="officer.person.last_name"></el-table-column>
				<el-table-column label="Gov ID" property="officer.person.gov_id"></el-table-column>
				<el-table-column label="Title" property="new_officer_title"></el-table-column>
				<el-table-column label="New Position" >
					<template slot-scope="scope">
							{{getOfficerPosition(scope.row.new_officer_position)}}
						</template>
				</el-table-column>
                 <el-table-column label="New Officer Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.new_officer_status==1">Appointed</span>
           				 <span v-if="scope.row.new_officer_status==2">Resigned</span>
          			</template>
                </el-table-column>
                <el-table-column label="Effective Date" property="effective_date_str"></el-table-column>
                 <el-table-column label="Change Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.status==1">Pending</span>
           				 <span v-if="scope.row.status==2">Waiting For Signature</span>
           				 <span v-if="scope.row.status==3">Signed</span>
           				 <span v-if="scope.row.status==4">Completed/Filed With ACRA</span>
           				 <span v-if="scope.row.status==5">Cancaelled</span>
          			</template>
                </el-table-column>
            </el-table>

          </div>
        </div>
      
      
      
 <div style="text-align:right">
              
</div>

<!-- end officer changes -->


<!-- start member changes:completed -->
<div  v-if="entity_type ==7">
<br/><br/><br/><br/>
<h5 class="title">Register Changes: Members</h5>
<div style=""></div>
        <div class="card" style="margin-bottom:50px">

          <div class="card-body table-responsive table-full-width">
            <el-table :data="memberChanges_completed" @row-click="">
                <el-table-column label="First Name" property="member.person.first_name" ></el-table-column>
                <el-table-column label="Last Name" property="member.person.last_name"></el-table-column>
				<el-table-column label="Gov ID" property="member.person.gov_id"></el-table-column>

                 <el-table-column label="New Member Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.new_member_status==1">Appointed</span>
           				 <span v-if="scope.row.new_member_status==2">Resigned</span>
          			</template>
                </el-table-column>
                <el-table-column label="Effective Date" property="effective_date_str"></el-table-column>
                 <el-table-column label="Change Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.status==1">Pending</span>
           				 <span v-if="scope.row.status==2">Waiting For Signature</span>
           				 <span v-if="scope.row.status==3">Signed</span>
           				 <span v-if="scope.row.status==4">Completed/Filed With ACRA</span>
           				 <span v-if="scope.row.status==5">Cancaelled</span>
          			</template>
                </el-table-column>
            </el-table>

          </div>
        </div>
      
      
      
	 <div style="text-align:right">
              
	</div>
</div>
<!-- end member changes -->


<!-- start member changes:completed -->
<div  v-if="entity_type ==7">
<br/><br/><br/><br/>
<h5 class="title">Register Changes: Members (Company)</h5>
<div style=""></div>
        <div class="card" style="margin-bottom:50px">

          <div class="card-body table-responsive table-full-width">
            <el-table :data="memberCompanyChanges_completed" @row-click="">
       			<el-table-column label="Company Name" property="member.shareholder_company.company_name" ></el-table-column>
                <el-table-column label="Company Registration Number" property="member.shareholder_company.company_reg_num"></el-table-column>


                 <el-table-column label="New Member Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.new_member_status==1">Appointed</span>
           				 <span v-if="scope.row.new_member_status==2">Resigned</span>
          			</template>
                </el-table-column>
                <el-table-column label="Effective Date" property="effective_date_str"></el-table-column>
                 <el-table-column label="Change Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.status==1">Pending</span>
           				 <span v-if="scope.row.status==2">Waiting For Signature</span>
           				 <span v-if="scope.row.status==3">Signed</span>
           				 <span v-if="scope.row.status==4">Completed/Filed With ACRA</span>
           				 <span v-if="scope.row.status==5">Cancaelled</span>
          			</template>
                </el-table-column>
            </el-table>

          </div>
        </div>
      
      
      
	 <div style="text-align:right">
              
	</div>
</div>
<!-- end member changes -->


<div v-if="entity_type!=7">
<!-- start share transactions:completed -->
<br/><br/><br/><br/>
<h5 class="title">Register Changes: Shares (Individuals)</h5>
<div style=""></div>


        <div class="card" style="margin-bottom:50px">

          <div class="card-body table-responsive table-full-width">
          
          
          
            <el-table :data="sharesChanges_completed" @row-click="goToEditShareTransaction">
                <el-table-column label="First Name" property="shareholder.person.first_name" ></el-table-column>
                <el-table-column label="Last Name" property="shareholder.person.last_name"></el-table-column>

                <el-table-column label="Share Type">
                	<template slot-scope="scope">
           				 <span v-if="scope.row.share_type===1">Ordinary</span>
           				 <span v-if="scope.row.share_type===2">Preference</span>

          			</template>
                </el-table-column>
                <el-table-column label="Number Of Shares" property="num_shares"></el-table-column>
                <el-table-column label="Transaction Type" >
                	<template slot-scope="scope">
           				 <span v-if="scope.row.transaction_type===1">Increase</span>
           				 <span v-if="scope.row.transaction_type===2">Decrease</span>
						 <span v-if="scope.row.transaction_type===3">Receiving From Another Shareholder</span>
						 <span v-if="scope.row.transaction_type===4">Transferring To Another Shareholder</span>
          			</template>
                </el-table-column>
                 <el-table-column label="Effective Date" property="effective_date_str"></el-table-column>
                 <el-table-column label="Change Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.status===1">Pending</span>
           				 <span v-if="scope.row.status===2">Waiting For Signature</span>
           				 <span v-if="scope.row.status===3">Signed</span>
           				 <span v-if="scope.row.status===4">Completed/Filed With ACRA</span>
           				 <span v-if="scope.row.status===5">Cancaelled</span>
          			</template>
                </el-table-column>
            </el-table>

          </div>
        </div>
      
      
<!-- end share transactions:completed -->




<!-- start share transactions:completed -->
<br/><br/><br/><br/>
<h5 class="title">Register Changes: Shares (Companies)</h5>
<div style=""></div>


        <div class="card" style="margin-bottom:50px">

          <div class="card-body table-responsive table-full-width">
          
          
          
            <el-table :data="sharesCompanyChanges_completed" @row-click="goToEditShareTransaction">
                <el-table-column label="Company Name" property="shareholder.shareholder_company.company_name" ></el-table-column>
                <el-table-column label="Company Registration Number" property="shareholder.shareholder_company.company_reg_num"></el-table-column>

                <el-table-column label="Share Type">
                	<template slot-scope="scope">
           				 <span v-if="scope.row.share_type===1">Ordinary</span>
           				 <span v-if="scope.row.share_type===2">Preference</span>

          			</template>
                </el-table-column>
                <el-table-column label="Number Of Shares" property="num_shares"></el-table-column>
                <el-table-column label="Transaction Type" >
                	<template slot-scope="scope">
           				 <span v-if="scope.row.transaction_type===1">Increase</span>
           				 <span v-if="scope.row.transaction_type===2">Decrease</span>
						 <span v-if="scope.row.transaction_type===3">Receiving From Another Shareholder</span>
						 <span v-if="scope.row.transaction_type===4">Transferring To Another Shareholder</span>
          			</template>
                </el-table-column>
                 <el-table-column label="Effective Date" property="effective_date_str"></el-table-column>
                 <el-table-column label="Change Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.status===1">Pending</span>
           				 <span v-if="scope.row.status===2">Waiting For Signature</span>
           				 <span v-if="scope.row.status===3">Signed</span>
           				 <span v-if="scope.row.status===4">Completed/Filed With ACRA</span>
           				 <span v-if="scope.row.status===5">Cancaelled</span>
          			</template>
                </el-table-column>
            </el-table>

          </div>
        </div>
      
      
<!-- end share transactions:completed -->


<!-- start share changes:completed -->
<!--
<br/><br/><br/><br/>
<h5 class="title">CHANGE: Share Certificate</h5>
        <div class="card" style="margin-bottom:50px">

          <div class="card-body table-responsive table-full-width">
            <el-table :data="shareCertChanges_completed" @row-click="goToEditChangeShareCert">
                <el-table-column label="Cert Num" property="share_certificate.cert_number" ></el-table-column>
                <el-table-column label="Change Type" >
                	<template slot-scope="scope">
           				 <span v-if="scope.row.type===1">Issue Certificate</span>
           				 <span v-if="scope.row.type===2">Cancel Certificate</span>

          			</template>
                	
                </el-table-column>	
                <el-table-column label="Effective Date" property="effective_date"></el-table-column>	
                 <el-table-column label="Change Status">
                 	<template slot-scope="scope">
           				 <span v-if="scope.row.status===1">Pending</span>
           				 <span v-if="scope.row.status===2">Waiting For Signature</span>
           				 <span v-if="scope.row.status===3">Signed</span>
           				 <span v-if="scope.row.status===4">Completed/Filed With ACRA</span>
           				 <span v-if="scope.row.status===5">Cancaelled</span>
          			</template>
                 </el-table-column>	
            </el-table>

          </div>
        </div>
      -->
      
      

<!-- end share cert changes:completed -->
</div>

			
			
<!-- start company info changes:completed -->
<br/><br/><br/><br/>
<h5 class="title">Changes: Company Info</h5>
<div style=""></div>
        <div class="card" style="margin-bottom:50px">

          <div class="card-body table-responsive table-full-width">
            <el-table :data="companyInfoChanges_completed" @row-click="goToEditChangeCompanyInfo">
                <el-table-column label="Type" property="ch_type_str" ></el-table-column>
                <el-table-column label="Changed To" property="value"></el-table-column>	
                 <el-table-column label="Filing Date" property="filing_date_str"></el-table-column>	
                <el-table-column label="Notes" property="notes"></el-table-column>	
            </el-table>

          </div>
        </div>
      
      
      



<!-- end company info changes:completed -->




    
    
    <div v-if="0" style="margin-bottom:50px;">
	<p-button type="info" @click="goToCreateOfficer()">
             <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                <span style="text-decoration:line-through">Create New Officer</span>
      </p-button>
    
    <p-button type="info" @click="goToCreateOfficerChange()">
             <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Create Change: Officers
      </p-button>
      
       <p-button type="info"  @click="goToCreateShareTransaction()" >
                Create Change: Shares
              </p-button>
              
	</div>
    <!-- end tab-pane:changes -->


</tab-pane>
   

 <tab-pane id="invoices" key="invoices">
              <span slot="title">Billing</span>
<!-- start invoices -->



			
		

<div style="margin-top:70px"></div>

		<div><h5 class="title">Billing Due</h5></div>
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="invoices" @row-click="goEditInvoice">
             <el-table-column label="Billing ID" property="id" sortable ></el-table-column>
             <el-table-column label="Created" property="created_at_str" ></el-table-column>
                <el-table-column label="Title" property="title" ></el-table-column>
                <el-table-column label="Description" property="description"></el-table-column>
                <el-table-column label="Amount" property="amount_str">
                	<template slot-scope="scope">
           				{{scope.row.amount_str}} {{scope.row.currency}}

          			</template>
                </el-table-column>
                <el-table-column label="Due Date" property="deadline_str"></el-table-column>
                  <el-table-column label="Payment">
                 	<template slot-scope="scope">
           				 <span v-if="scope.row.status===1">Not Paid</span>
           				 <span v-if="scope.row.status===2">Paid</span>
						 <span v-if="scope.row.status===3">Cancelled</span>
          			</template>
                 </el-table-column>	
            </el-table>

          </div>
        </div>
        
        
        
        <div><h5 class="title">Recurring Bills</h5></div>
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="recurring_bills" @row-click="goEditRBill">
                <el-table-column label="Title" property="title" ></el-table-column>
                <el-table-column label="Description" property="description"></el-table-column>
                <el-table-column label="Amount" property="amount_str">
                	<template slot-scope="scope">
           				{{scope.row.amount_str}} {{scope.row.currency}}

          			</template>
                </el-table-column>
                <el-table-column label="Billing Date" property="deadline_str"></el-table-column>
               <el-table-column label="Billing Cycle">
                 	<template slot-scope="scope">
           				 <span v-if="scope.row.billing_cycle===1">Annually</span>
           				 <span v-if="scope.row.billing_cycle===2">Monthly</span>
          			</template>
                 </el-table-column>	
                  <el-table-column label="Status">
                 	<template slot-scope="scope">
           				 <span v-if="scope.row.status===1">Active</span>
           				 <span v-if="scope.row.status===2">Cancelled</span>
          			</template>
                 </el-table-column>	
                 
            </el-table>

          </div>
        </div>
      
      
    

<!-- end documents -->
   <h4 style="font-weight:bold;">Actions</h4>
   <card>
    <div style="">
	 <p-button type="info"  @click="goCreateRecurringBill()" >
				  <i slot="label" class="nc-icon nc-settings-gear-65"></i>
				 Create Recurring Bill
		 </p-button>     
	</div>
	</card>

</tab-pane>

	<tab-pane id="key_docs" key="key_docs">
	  <span slot="title">
		  Key Documents
	  </span>
	 	
	 	<card style="margin-top:50px;">
        <h5 style="font-weight:bold;">Upload Key Document</h5>
          <div class="col-sm-7">
      	   <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Document Type"
                             v-model="new_key_document.type">
                    <el-option v-for="option in selects.key_doc_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
                </div>
                
                
            
             <div class="col-sm-7" v-if="new_key_document.type=='custom_document'">    
                 <fg-input type="text"
                  name="document name"
				  label="Document Name"                  
                  v-model="new_key_document.document_name">
       			 </fg-input>
            </div>
        
        	
        	
        	
        	<div class="col-sm-7">    
                 <fg-input type="text"
                  name="remarks"
				  label="Remarks"                  
                  v-model="new_key_document.remarks">
       			 </fg-input>
            </div>
        	
        	<div style="margin-top:30px;"><input type="file" id="file" ref="new_file" class="btn btn-default" /></div>
        	
        	<p-button    @click.prevent="uploadKeyDocFile()" type="info" style="width:100%;">
   				 <i slot="label" class="nc-icon nc-cloud-upload-94"></i>
           				Upload File
   			 </p-button> 
        </card>
	 	
	 	

        <div class="card" style="margin-bottom:50px;margin-top:100px;">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="key_documents">
                <el-table-column label="Title" property="doc_name" ></el-table-column>
                <el-table-column label="Uploaded" property="created_at_str"></el-table-column>
                 <el-table-column label="Remarks" property="notes"></el-table-column>
    
                    <el-table-column label="" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="viewKeyDocument(scope.row.document_id)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>
                 
            </el-table>

          </div>
        </div>
	 	
	 	
	    	
    
    	
    	
    	
    	
        
	 
	  
	 </tab-pane> 
	 
	 
    </tabs>
    
    

  </div>
</template>
<script>
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn} from 'element-ui'
  import {CommonService} from 'src/services/common.service'
 
  
  export default {
    components: {
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
     mounted() {
     	this.loadEntityInfo();
    },
    data () {
      return {
        activeName: 'first',
        enabledRadio: '2',
        entity_type: '',
        key_contact:[],
        coy:[],
        role:'',
        officers:[],
        shareholders: [],
        documents:[],
        invoices:[],
        recurring_bills:[],
        notifications:[],
        uploaded_file: '',
        key_documents:[],
        new_key_document:{
        	document_name:'',
        	type:'',
        	file:'',
        	remarks:'',
        },
        displayTaskCat: 99,
        displayCreateCustomShareType: false,
        new_file_doc_type:'acra_biz_profile',
        selects: {
          key_doc_type: [
            {value: 'acra_biz_profile', label: 'ACRA Business Profile'},
            {value: 'constitution', label: 'Company Constitution'},
            {value: 'register_of_members', label: 'Register Of Members'},
            {value: 'register_of_directors', label: 'Register Of Directors'},
            {value: 'register_of_secretaries', label: 'Register Of Secretaries'},
            {value: 'register_of_controllers', label: 'Register Of Registrable Controllers'},
         //   {value: 'custom_document', label: 'Custom Document'},
		   ],
		},
        tasks:[],
        tasks_incomplete:[],
        tasks_completed:[],
        sharetransactions:[],
        sharesChanges_completed: [],
        sharesChanges_pending: [],
        sharesCompanyChanges_completed: [],
        sharesCompanyChanges_pending: [],
        poc:{ //point of contact
            first_name:'-',
            last_name:'-',
            gov_id:'-',
            contact_num:'-',
            email:'-',
        
        },
        new_share_type:{
        	name:'',
        },
        officerChanges:[],
        officerChanges_completed:[],
        officerChanges_pending:[],
        memberChanges_completed:[],
        memberCompanyChanges_completed:[],
        officers_appointed:[],
        officers_resigned:[],
        officers_unconfirmed:[],
        members_appointed:[],
        members_resigned:[],
        members_unconfirmed:[],
        members_company_appointed:[],
        members_company_resigned:[],
        shareCertChanges_pending:[],
        shareCertChanges_completed:[],
        shareholders_inactive: [],
        shareholders_active: [],
        shareholder_companies_inactive:[],
        shareholder_companies_active:[],
        register_controllers:[],
        companyInfoChanges_pending:[],
        companyInfoChanges_completed:[],
        
      }
    },
    methods:{
    	 uploadKeyDocFile(){
    	 	   if(!this.new_key_document.type || !this.$refs.new_file.files[0]){
    	 	   
    	 	   	return false;
    	 	   }
    	 
    	 
    	 		if(this.new_key_document.type == "custom_document" && this.new_key_document.document_name==""){
    	 			  swal({
						  title: 'Oops',
						  text: 'Please enter a name for this document.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
    	 			return false;
    	 		}
    	 
    	 
    	 		swal.showLoading();
      			let uploaded_file = this.$refs.new_file.files[0];
      			let formData = new FormData();
  			    formData.append('file', uploaded_file);
  			    formData.append('kd_type', this.new_key_document.type);
  			    formData.append('kd_document_name', this.new_key_document.document_name);
  			    formData.append('kd_remarks', this.new_key_document.remarks);
  			    
  			    const vm = this;
  			    if(this.new_key_document.document_name ==""){
  			    	this.new_key_document.document_name = '-';
  			    }
  			    
  			     let uri = this.$base_url+'/api/v1/documents/upload_key_doc/'+ this.$route.params.id;
				 ApiService.post(uri,formData).then(response => {
						swal({
						  title: 'Uploaded.',
						  text: 'The file has been uploaded.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
								swal.close();
								vm.new_key_document.document_name = '';
								vm.loadEntityInfo();
						})//end swal
			
				  })
      	
      	
      	},
      
    	handleFileUpload(type){
    		if(type=="acra_biz_profile"){
    			this.uploaded_file = this.$refs.key_doc_acra_biz_profile.files[0];
    		}
    		else if(type=="constitution"){
    			this.uploaded_file = this.$refs.key_doc_constitution.files[0];
    		}
    		
    		
    		this.submitFile(type);
    		
  		},
  		submitFile(type){
  				let formData = new FormData();
  			    formData.append('file', this.uploaded_file);
  			    
  			     let uri = this.$base_url+'/api/v1/documents/upload_key_doc/'+ this.$route.params.id +'/'+type;
				 ApiService.post(uri,formData).then(response => {
						
			
				  })
  		
  		},
       displayCreateCustomShareTypeForm(){
       		if(this.displayCreateCustomShareType == false){
       			this.displayCreateCustomShareType = true;
       		}
       		else{
       			this.displayCreateCustomShareType = false;
       		}
       },
       loadEntityInfo(){
       
       	swal.showLoading();
      	let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.id;
     	 ApiService.get(uri).then(response => {
      	    
      	    let e =  response.data.entity;
      	    
      	    this.entity_type = e.company_type;
      	    
      	    
      	    var entityTypeList = this.$entity_type;
      	    var entityStatusList = this.$entity_status;
      	    
      	   
			for (var i = 0; i < entityTypeList.length; i++) {
				if(e.company_type==entityTypeList[i]["value"]){
					e.company_type = entityTypeList[i]["label"];
					break;
				}
			}
			
			for (var i = 0; i < entityStatusList.length; i++) {
				if(e.company_status == entityStatusList[i]["value"]){
					e.company_status = entityStatusList[i]["label"];
					break;
				}
			}
      	    
      	    
      	    
      	    if(response.data.point_of_contact){
      	    	this.poc = response.data.point_of_contact;
      	    }
      	    
      	    if(response.data.register_controllers){
      	    	this.register_controllers = response.data.register_controllers;
      	    	
      	    }
      	    this.role = response.data.role;
         	this.coy = e;
         	this.officers = e.officers;
         	this.shareholders = e.shareholders;
         	this.sharetransactions = e.share_transactions;
         	this.officerChanges = e.officer_changes;
         	this.invoices = e.invoices;
         	this.recurring_bills = e.recurring_bills;
         	
         	this.tasks = e.tasks_;
         	this.tasks_incomplete = response.data.tasks_incomplete;
         	this.tasks_completed = response.data.tasks_completed;
         	
         	this.officers_appointed =  response.data.officers_appointed;
         	this.officers_resigned =  response.data.officers_resigned;
         	this.officers_unconfirmed =  response.data.officers_unconfirmed;
         	
         	
         	this.members_appointed =  response.data.members_appointed;
         	this.members_resigned =  response.data.members_resigned;
         	this.members_unconfirmed =  response.data.members_unconfirmed;
         	
         	this.members_company_appointed = response.data.members_company_appointed;
         	this.members_company_resigned = response.data.members_company_resigned;
         	
         	this.shareholders_inactive = response.data.shareholders_inactive;
         	this.shareholders_active = response.data.shareholders_active;
         	
         	this.shareholder_companies_inactive = response.data.shareholder_companies_inactive;
         	this.shareholder_companies_active = response.data.shareholder_companies_active;
         	
         	this.officerChanges_completed = response.data.officerChanges_completed;
         	this.officerChanges_pending = response.data.officerChanges_pending;
         	
         	this.memberChanges_completed = response.data.memberChanges_completed;
         	this.memberCompanyChanges_completed = response.data.memberCompanyChanges_completed;
         	
         	this.sharesChanges_completed = response.data.sharesChanges_completed;
         	this.sharesChanges_pending = response.data.sharesChanges_pending;
         	
         	this.sharesCompanyChanges_completed = response.data.sharesCompanyChanges_completed;
         	this.sharesCompanyChanges_pending = response.data.sharesCompanyChanges_pending;
			
			this.companyInfoChanges_pending = response.data.companyInfoChanges_pending;
			this.companyInfoChanges_completed = response.data.companyInfoChanges_completed;
			
			this.shareCertChanges_pending = response.data.shareCertChanges_pending;
			this.shareCertChanges_completed = response.data.shareCertChanges_completed;
			
			this.documents = e.documents;
			this.key_documents = response.data.key_documents;
			
			if(response.data.entity.entity_key_contact_person){
				this.key_contact = response.data.entity.entity_key_contact_person;
			}
			
			if(response.data.notifications){
				this.notifications = response.data.notifications;
			
			}
         	swal.close();
      	})
       },
      getCitizenship(code){
      		
      		return CommonService.getCitizen(code);
      },
      getCountry(code){
      		
      		return CommonService.getCountry(code);
      },
      
      getOfficerPosition(code){
      		
      		return CommonService.getOfficerPosition(code);
      },
      scRowClassName({ row }){
    		if(row.status == 4){
    			return "table-success";
    		}
    		else if(row.status == 5){
    			return "cs-strikethrough";
    		}
    	
      },
      goToCert(row){
      	this.$router.push( '/view-share-cert/'+row.id+'/entity/'+this.$route.params.id)
      },
      officerPocRowClassName({row}){
      		if(row.pivot.is_contact_person == 1){
      			return "table-success";
      		}
      },
      filterTag(value, row) {
        return row.category === value;
      },
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.id);
	  },
	  goToCompanyRegister(){
	  	 this.$router.push( '/company-register/'+this.$route.params.id);
	  
	  },
      viewDocument(did){
      	this.$router.push( '/view-document/'+ did+"/0");
      },
      viewKeyDocument(did){
      	this.$router.push( '/view-key-document/'+ did);
      },
      goCreateRecurringBill(){
      	 this.$router.push( '/edit-recurring-bill/0/entity/'+this.$route.params.id)  
      },
      goEditInvoice(row){
      	 var tid = 0;
      	 if(row.task_id){
      	 	tid = row.task_id
      	 }
      	 this.$router.push( '/edit-invoice/'+row.id+'/entity/'+this.$route.params.id+"/task/"+tid)  
      },
      goEditRBill(row){
      	  this.$router.push( '/edit-recurring-bill/'+row.id+'/entity/'+this.$route.params.id)  
      },
      goCreateInvoice(){
      	 this.$router.push( '/edit-invoice/0/entity/'+this.$route.params.id)  
      },
       goToEditOfficerChange(row){
      	  this.$router.push( '/create-officer-change/'+row.id+'/entity/'+this.$route.params.id+"/edit")  
      },
      goToEditChangeCompanyInfo(row){
      	this.$router.push( '/edit-change-company-info/'+row.id+'/entity/'+this.$route.params.id)  
      },
       goToEditChangeShareCert(row){
      	this.$router.push( '/edit-change-share-cert/'+row.id+'/entity/'+this.$route.params.id)  
      },
      
      goToEditShareTransaction(row){
      	  this.$router.push( '/create-share-transaction/'+row.id+'/entity/'+this.$route.params.id+"/edit")  
      },
      goToCreateShareTransaction(){
      		 this.$router.push( '/create-share-transaction/0/entity/'+this.$route.params.id+"/create")  
       },
       goToDigitalMailbox(){
      		 this.$router.push( '/digital-mailbox/'+this.$route.params.id)  
       },
       goToEntityDocuments(){
      		 this.$router.push( '/entity-documents/'+this.$route.params.id)  
       },
      goToResolutionBuilder(){
      		this.$router.push( '/resolution-builder/0/entity/'+this.$route.params.id)  
      },
      goToClientPortalInfo(){
      	 this.$router.push( '/client-portal/'+this.$route.params.id)  
      },
      goToEntityAssociates(){
      	 this.$router.push( '/entity-associates/'+this.$route.params.id)  
      },
      createAgmTask(){
      
      	  let uri = this.$base_url+'/api/v1/tasks/create_agm/'+ this.$route.params.id;
     	  ApiService.get(uri).then(response => {
     	  		
     	  		 let agm =  response.data.agm_task;
     	  		 this.$router.go();
     	  
     	  });
    
      },
     createShareType() {

    		let uri = this.$base_url+'/api/v1/shareholders/create_share_type';
      		ApiService.post(uri, {
      				'share_type':this.new_share_type,
      				'eid':this.$route.params.id,
      		
      				}).then(response => {
      	
         			this.$router.go();
         		
     		 })
  		  
      },
      gotoEditTask(row){
      	this.$router.push( '/edit-task/'+row.id+'/entity/'+this.$route.params.id)
      },
      viewOfficer (row) {
        this.$router.push( '/view-officer/'+row.id+"/entity/"+this.$route.params.id)
      },
      viewShareholder (row) {
        this.$router.push( '/edit-shareholder/'+row.id+"/entity/"+this.$route.params.id+"/" + row.pivot.share_type)
      },
      viewShareholderCompany (row) {
        this.$router.push( '/edit-shareholder-company-details/'+row.id+"/entity/"+this.$route.params.id+"/" + row.pivot.share_type)
      },
      viewCompanyShareholder(row){
      	//this.$router.push( '/edit-shareholder-company/'+row.id)
      },
      goToCreateTask(){
      	  this.$router.push( '/edit-task/0/entity/'+this.$route.params.id);
      },
      goToCreateOfficer(){
      	 this.$router.push( '/create-officer/0/entity/'+this.$route.params.id)
      },
      goToCreateOfficerChange(){
      	 this.$router.push( '/create-officer-change/0/entity/'+this.$route.params.id+"/create")
      },
      goToEditOfficer($oid){
      	 this.$router.push( '/create-officer/'+$oid+'/entity/'+this.$route.params.id)
      },
      
       goEditEntity:function(){
       		this.$router.push( '/create-entity/'+ this.$route.params.id)
       },
       
       updateEntityFye(){
       	const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'The financial year-end date for this entity will be increased by 1 year.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/entities/update_fye/entity/'+vm.$route.params.id;
     	  ApiService.get(uri).then(response => {
				swal({
				  title: 'Done.',
				  text: 'The financial year-end has been updated.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					//vm.$router.go()
					vm.loadEntityInfo();
				})
				//end swal
            })
         
            
          })
       
       
       
       
       },
      updateEntityFsFiling(){
       	const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'You are indicating that the financial statements have been filed for this financial year.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/entities/update_fs_filing/entity/'+vm.$route.params.id;
     	  ApiService.get(uri).then(response => {
				swal({
				  title: 'Done.',
				  text: 'The financial statements filing status has been updated for this financial year.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					//vm.$router.go()
					vm.loadEntityInfo();
				})
				//end swal
            })
         
            
          })
       
       
       
       
       },
       updateEntityAGMFiling(){
       		const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'You are indicating that the AGM has been completed for this current year.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/entities/update_filing_status/entity/'+vm.$route.params.id+"/agm";
     	  ApiService.get(uri).then(response => {
				swal({
				  title: 'Done.',
				  text: 'The AGM status has been updated for this financial year.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					//vm.$router.go()
					vm.loadEntityInfo();
				})
				//end swal
            })
         
            
          })
       
       
       
       
       
       
       },
       
       updateEntityARFiling(){
       		const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'You are indicating that the annual return has been completed for this current financial year.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/entities/update_filing_status/entity/'+vm.$route.params.id+"/ar";
     	  ApiService.get(uri).then(response => {
				swal({
				  title: 'Done.',
				  text: 'The annual return status has been updated for this financial year.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					//vm.$router.go()
					vm.loadEntityInfo();
				})
				//end swal
            })
         
            
          })
       
       
       
       
       
       
       },
       
       deleteOfficer: function (oid) {
  
       	const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'Officer will be deleted from all entities he/she is linked to.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = this.$base_url+'/api/v1/officers/delete/'+ oid;
     	  ApiService.get(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'The officer has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					vm.$router.go()
				
				})
				//end swal
            })
         
            
          })
       }, //end deleteOfficer 
       
       deleteEntity: function () {
        let eid = this.$route.params.id;
       	const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/entities/delete/'+ eid;
     	  ApiService.get(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'The entity has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					vm_.$router.push( '/companies')
				
				})
				//end swal
            })
         
            
          })
       }//end deleteEntity 
    },

    
  }
</script>
<style>

.cs_coy_detail_row{
	margin-top:25px;margin-bottom:25px;
}
.cs_coy_detail_label{
	font-weight:bold!important;
	color:#000!important;
	text-align:left!important;
}

 .cs_coy_detail1{
 	padding:10px 5px;
 	padding-left:2px;
 	border-bottom:1px dotted #000;
 }

@media screen and (max-width: 480px) {
	.cs_coy_detail_label1{
		text-align:left!important;
	}	
}



</style>
